import { render, staticRenderFns } from "./ParcelDetailDesktop.vue?vue&type=template&id=758c76c8&"
import script from "./ParcelDetailDesktop.vue?vue&type=script&lang=js&"
export * from "./ParcelDetailDesktop.vue?vue&type=script&lang=js&"
import style0 from "./ParcelDetailDesktop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports